<template>
<div class="col-md-12 order-container">
    <div
      class="col-md-12 float-center">
    <vueper-slides autoplay :duration=6000 fixed-height="300px">
        <vueper-slide v-for="(com, i) in this.comunicados"
            :slideImageInside="true"
            :key="i"
            :image="server + com.imagenComunicacion"
            @click.native="imageNavigate(com.enlaceComunicacion)" />
    </vueper-slides>
    </div>
</div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
    components: {
        VueperSlides,
        VueperSlide
    },
    computed: {},
    data() {
        return {
            server: "",
            comunicados: []
        }
    },
    async created() {
        this.server = process.env.VUE_APP_API_ENDPOINT;
        //this.server = "https://redi-qa-backoffice.azurewebsites.net/";
    },
    async mounted() {
        await this.init()
    },
    methods: {
        async init() {
        this.$swal.fire({
            title: this.$t("app.promps.wait"),
            html:
            '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
            showConfirmButton: false
        });
        await this.getItems();
        this.$swal.close();
        },
        async getItems() {
        const params = {
            Id: 0,
            ClaveIdioma: this.$store.state.lang
        };

        await this.$http
            .post(route("Comunicaciones/getComunicacionesPublic"), params)
            .then(
                response => {
                    if (response.body.code === 200) {
                        this.comunicados = response.body.comunicaciones.filter(c => c.activo);
                    } else {
                    console.log(response.body);
                    // this.processError(response.body)
                    }
                },
                error => {
                    console.error(error);
                    // this.processError(error)
                }
            );
        },
        imageNavigate(link) {
            // console.log(link);
            window.open(link, '_blank').focus();
        }
    }
}
</script>

<style>

.carousel-container{
    margin-top: 20px;
}

.carousel-row{
    max-height: 300px;
    min-height: 200px;
    height: auto;
    padding: 20px;
}

.carousel-item-color{
    background-color: #e31d1a;
    color: white;
    padding: 100px 0px 0px 80px;
    border-radius: 20px 0px 0px 20px;
    overflow: hidden;
    height: 280px;
}

.carousel-item-text{
    font-weight: bold;
    font-size: 14px;
}

.carousel-item-image{
    overflow: hidden;
}

.carousel-item-image img{
    width: 100%;
    height: auto;
}


.vueperslide, .vueperslide__image {
  background-size: cover !important;
  background-repeat: no-repeat;
  background-color: transparent;
}
</style>
